// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","chip":"selectedOption_chip__rFiIm"};